import { useDispatch } from '../../../Flux/index.ts'
import type { ReactNode } from 'react'
import type { DraftState } from '../../../Model/OrderWizard/OrderWizardDraft.ts'
import { dropFiles } from '../../../Services/OrderWizard/dropFiles.ts'
import { useFilePicker } from './useFilePicker.tsx'

const SHEET_ACCEPT = '.csv,.tsv,.xlsx,.xls'

/** Picks a sample sheet and adds it the way a drop on the page does. */
export const SheetPicker = ({
  draft,
  className,
  testId,
  children
}: {
  draft: DraftState
  className: string
  testId: string
  children: ReactNode
}) => {
  const dispatch = useDispatch()
  const picker = useFilePicker({ accept: SHEET_ACCEPT, multiple: false, onFiles: (files) => dropFiles(draft.id, files, dispatch) })
  return (
    <>
      <button type="button" className={className} data-testid={testId} onClick={picker.open}>
        {children}
      </button>
      {picker.input}
    </>
  )
}
